import initialState from './initialState'

/**
 * @description
 * set status, token, user and hasLoadedOnce after success user login
 *
 * @param {object} state
 * @return {void}
 */
const authSuccess = (state, token) => {
    state.status = 'success'
    state.token = token
    state.user = localStorage.getItem('user')
    state.hasLoadedOnce = true
}

/**
 * @description
 *
 * set token to void after user logout
 * @param {Object} state
 * @return {void}
 */
const authLogout = state => {
    state.token = ''
}

const SET_USER = (state, user) => (state.user = user)
const SET_TOKEN = (state, token) => (state.token = token)
const SET_GROUND_SELLER = (state, groundSeller) =>
    (state.groundSeller = groundSeller)
const SET_POS_WORKSTATION_TYPE = (state, type) =>
    (state.posWorkstationType = type)

/**
 * @description
 *
 * Returns State to it's initial values
 * @param {*} state
 */
const resetState = state => {
    Object.assign(state, initialState())
}

export default {
    authSuccess,
    authLogout,
    resetState,
    SET_USER,
    SET_TOKEN,
    SET_GROUND_SELLER,
    SET_POS_WORKSTATION_TYPE,
}
